<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-2">
        <img src="assets/img/conta-publica.png" alt="" width="42" height="42">
      </div>
      <div class="col-10">
        <a [routerLink]="['/transparencia/portal']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="pt-3 mb-0 pb-0">
          <p style="margin-bottom: 1px;"
            [ngClass]="this.login.contraste ? 'titulo-contraste fonte-acessibilidade' : 'titulo-normal fonte-acessibilidade'">
            CONTAS PÚBLICAS
          <p style="margin-top: 1px;"
            [ngClass]="this.login.contraste ? 'texto-contraste fonte-acessibilidade' : 'texto-normal fonte-acessibilidade'">
            Destinado a organizar e viabilizar a ação pública, com vistas a
            cumprir os fundamentos e os objetivos da município.</p>
        </div>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
    <div class="row">
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'">
              Tributos arrecadados</h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              A receita tributária própria municipal é composta de impostos, taxas e contribuições. Os impostos
              municipais são: Imposto predial e territorial urbano (IPTU); Imposto sobre serviços de qualquer
              natureza (ISSQN), etc;
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
            [routerLink]="['/transparencia/receitas-orcamentarias/pesquisa', 'impostos', 1, data1, data2]">Acessar</a>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'">
              Anexos Lei nº 4.320/64</h6>
            <p class="card-text" style="text-align: justify">
              Lei elaborada pelo Poder Executivo que estabelece as despesas e as receitas que serão realizadas no próximo ano.
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              routerLink="/transparencia/loa">Acessar</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'">
              Execução orçamentária</h6>
            <p class="card-text" style="text-align: justify">
              Execução orçamentária é a utilização dos créditos consignados no Orçamento Geral da União Europeia e nos
              créditos adicionais, visando à realização dos subprojetos e/ou subatividades atribuídos às unidades
              orçamentárias.
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              routerLink="/transparencia/execucao-orcamentaria/balancetes">Acessar Balancetes</a>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade ml-3' : 'btn btn-sm btn-primary fonte-acessibilidade ml-3'"
              routerLink="/transparencia/execucao-orcamentaria/lrf">Acessar Anexos LRF</a>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'">
              Ordem de Fornecimento</h6>
            <p class="card-text" style="text-align: justify">
              As ordens de fornecimento ou serviço nada mais são do que comandos concretos expedidos pela Administração
              para que o contratado realize os fornecimentos em quantidade, prazo e local definidos no edital, em razão
              das demandas efetivas que precisam ser satisfeitas.
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
            [routerLink]="['/transparencia/compras/pesquisa', 1, data1, data2]">Acessar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
